import { employeeStore, payrollStore } from '../../stores';
import { PayrollSummary, ViewPayroll } from '../../pages';
import { PayrollController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { object, string } from 'yup';
import moment from 'moment';
import { toJS } from 'mobx';

const PayrollSummaryContainer = ({ closeModal }) => {
	const [loading, setLoading] = useState(false);
	const [stage2, setStage2] = useState(false);

	const goBack = () => {
		if (stage2) {
			setStage2(false);
		} else {
			closeModal();
		}
	};

	const onSubmit = async payload => {
		setLoading(true);

		delete payload.employeeGroupName;
		delete payload.departmentName;
		
		let query = '';
		for (const key in payload) {
			if (payload[key] !== '') {
				query += `${key}=${payload[key]}&`;
			}
		}
		const { status, errorMessage } = await PayrollController.payrollSummaries(
			query
		);
		setLoading(false);
		if (status === constant.Success) {
			setStage2(true);
			return MimaToastUtil.success({
				message: constant.Success,
			});
		}
		MimaToastUtil.error({
			message: errorMessage,
		});
	};

	const schemaValidation = () => {
		return object({
			month: string().required('Month is required'),
			year: string().required('Year is required'),
		});
	};
	const statuses = [
		constant.STATUS.PENDING,
		constant.STATUS.REQUEST_CHANGE,
		constant.STATUS.APPROVED,
		constant.STATUS.IN_REVIEW,
		constant.STATUS.REVIEWED,
		constant.STATUS.IGNORE,
		constant.STATUS.PAID,
		constant.STATUS.FAILED,
		constant.STATUS.PROCESSING,
		constant.STATUS.REVERSED,
	].map(status => {
		return {
			key: status,
			value:
				status === constant.STATUS.REVIEWED
					? `${status}/${constant.STATUS.PARTIALLY_REVIEWED}`
					: status,
		};
	});

	const months = moment.months().map(month => {
		return {
			key: `${month}`,
			value: `${month}`,
		};
	});
	const years = () => {
		const year = new Date().getFullYear();
		return Array.from({ length: 3 }, (v, i) => year - 3 + i + 1).map(yr => {
			return {
				key: `${yr}`,
				value: `${yr}`,
			};
		});
	};

	return (
		<PayrollSummary
			closeModal={closeModal}
			onSubmit={onSubmit}
			months={months}
			years={years()}
			schemaValidation={schemaValidation}
			departments={toJS(employeeStore.mapDepartments)}
			employeeGroups={toJS(employeeStore.mapGroups)}
			tags={toJS(payrollStore.tags)}
			statuses={statuses}
			loading={loading}
			payrollSummary={payrollStore.payrollSummaries?.[0] || {}}
			stage2={stage2}
			goBack={goBack}
		/>
	);
};

export default observer(PayrollSummaryContainer);
